
define('utilities',[
    "jquery",
    "underscore",
    "logging",
    "modernizr"
], function ($, _, logging) {
    var _ModuleName = "Utilities";
    var _DeviceScreenWidth = $(window).width();
    var _ScreenMaxWidth = {
        Large: 1300,
        Medium: 1000,
        Small: 768,
        XSmall: 480
    };
    var _DeviceType = {
        get Phone() { return _DeviceScreenWidth < _ScreenMaxWidth.Small; },
        get Tablet() { return _DeviceScreenWidth < _ScreenMaxWidth.Large && !this.Phone; },
        get Desktop() { return !this.Phone && !this.Tablet; }
    };

    var DocumentReady = false;
    var _Intialized = false;
    var _ReadyMonitor = {};
    var _Environments = { 
        Production: "production",
        Development: "development",
        Staging: "staging"
    }
    var _CurrentEnvironment = _Environments.Production;
    var _docReadyConfig = {
        event: {
            name: "patheos.documentready"
        }
    };

    var _sixseedsBlogs = [
        "rolandwarren",
        "clippityclip",
        "notinggrace",
        "bootcampaign",
        "timwright",
        "jenniferchronicles",
        "showhope",
        "devonfranklin",
        "watchinggod",
        "askshaunti",
        "ashleywillis",
        "davewillis",
        "shaeffersghost",
        "jeffandalyssa",
        "seanlowe",
        "searchingfortomsawyer",
        "zekepipher",
        "churchformen",
        "frenchrevolution"
    ];

    function init() {
        if (_Intialized) return;

        // Initialize Document Ready
        _initDocumentReady();

        // initialize all fallback capabilities
        fallback();
        
        // cache a couple dom objects
        $window = $(window);

        // Set Environment
        if(location.hostname == "local.patheos.com"
            || location.hostname == "localwp.patheos.com"
            || location.hostname == "dev.patheos.com") {
            _CurrentEnvironment = _Environments.Development;
        }
        else if(location.hostname == "stage.patheos.com") {
            _CurrentEnvironment = _Environments.Staging;
        }
        else {
            _CurrentEnvironment = _Environments.Production;
        }
        
        console.log("Environment: " + _CurrentEnvironment);

        // initialize logging
        var enableLogging = getParameter(document.URL, 'patheos_debug')
        logging.init(enableLogging == "true" || enableLogging == "1" || isDevelopment() || isStaging());
        
        ;

        /* ============ Handle Mobile Detection ============ */

        ;
        ;

        DocumentReady = false;

        documentReady(function () {
            ;
            DocumentReady = true;
        });

        _Intialized = true;
        ;
    }

    /**
     * INitializes the document ready with a jquery based back-up
     */
    function _initDocumentReady() {
        window.bnm = window.bnm || { };
        window.bnm.ready = window.bnm.ready || false;

        ;
        // If ready is already marked, trigger event
        if(window.bnm.ready == true) {
            ;
            _triggerDocumentReady();

        // otherwise set up a backup using jquery just in case our event fails to fire
        } else {
            ;
            // If jquery fires first, go ahead and fire our event
            $(function() {
                if(window.bnm.ready === false) {
                    ;

                    // Trigger Document Ready
                    _triggerDocumentReady();
                }
            });
        }
    }

    /**
     * Safe Document Ready Handler
     * @param {function} callback 
     */
    function documentReady(callback) {
        // If callback is not a function, just bail
        if(typeof callback !== 'function') return;

        // If document is already ready, just run the callback
        if(window.bnm.ready) {
            ;
            callback();
        
        // otherwise, add event listener
        } else {
            ;
            // Add an event listener
            document.addEventListener(_docReadyConfig.event.name, function(e) {
                ;
                callback();
            });
        }
    }

    /**
     * Trigger the document ready
     */
    function _triggerDocumentReady() {
        if(window.bnm.ready === false) {
            ;
            
            // Set value to true
            window.bnm.ready = true;
            
            // Create the event
            var event = new CustomEvent(_docReadyConfig.event.name);

            // Dispatch/Trigger/Fire the event
            document.dispatchEvent(event);
        }
    }

    /**
     * Finds youtube embedded iframes and fixes them on mobile
     */
    function fixYouTubeResponsive() {
        // Loop through each iframe
        $('iFrame').each(function(idx, elem) {
            var $frame = $(elem);
            // If the iframe references youtube.com as its source
            var source = $frame.attr('src');
            if(source && source.indexOf("youtube.com") > -1) {
                // fix it's sizes
                var parentWidth = $frame.parent().width();
                var playerHeight = Math.floor(parentWidth / 16 * 9); // 16x9 aspect ratio

                $frame.attr('width', parentWidth);
                $frame.attr('height', playerHeight);
            }
        });
}

    function fallback() {
        /* ============ Fix SVGs on Old Browsers ============ */
        /* Use Modernizr to check for SVG support, fall back to PNG if support is lacking */
        if (!Modernizr.svg) {
            var imgs = document.getElementsByTagName('img');
            var endsWithDotSvg = /.*\.svg$/
            var i = 0;
            var l = imgs.length;
            for (; i != l; ++i) {
                if (imgs[i].src.match(endsWithDotSvg)) {
                    imgs[i].src = imgs[i].src.slice(0, -3) + 'png';
                }
            }
        }
    }

    function isDevelopment() {
        return _CurrentEnvironment == _Environments.Development;
    }

    function isStaging() {
        return _CurrentEnvironment == _Environments.Staging;
    }

    // Get Cookie Data by Name
    function getCookie(sName) {
        sName = sName.toLowerCase();
        var oCrumbles = document.cookie.split(';');
        for (var i = 0; i < oCrumbles.length; i++) {
            var oPair = oCrumbles[i].split('=');
            var sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
            var sValue = oPair.length > 1 ? oPair[1] : '';
            if (sKey == sName)
                return decodeURIComponent(sValue);
        }
        return '';
    }

    // Set cookie name/value
    function setCookie(sName, sValue) {
        setCookie(sName, sValue, 365);
    }

    // Set cookie name/value/expiration (days)
    function setCookie(sName, sValue, expDays) {
        var oDate = new Date();
        oDate.setDate(oDate.getDate() + expDays);
        var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/';
        document.cookie = sCookie;
    }

    // Set cookie name/value/expiration (hours)
    function setCookieByHours(sName, sValue, expHours) {
        var oDate = new Date();
        oDate.setTime(oDate.getTime() + (expHours*60*60*1000));
        var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/';
        document.cookie = sCookie;
    }

    // Get URL Parameter
    function getParameter(url, name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(url);
        var response = results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        return response == null ? "" : response;
    }

    function cleanString(s) {
        s = s.replace(/[\n\r]+/g, '');
        s = s.replace(/\s{2,10}/g, ' ');

        return s;
    }

    function htmlSubstring(s, n) {
        var m, r = /<([^>\s]*)[^>]*>/g,
            stack = [],
            lasti = 0,
            result = '';

        //for each tag, while we don't have enough characters
        while ((m = r.exec(s)) && n) {
            //get the text substring between the last tag and this one making sure not to split in the middle of a word
            var mod = s.substring(lasti, m.index).indexOf(' ', n); n = mod !== -1 ? mod : n;
            var temp = s.substring(lasti, m.index).substr(0, n);
            //append to the result and count the number of characters added
            result += temp;
            n -= temp.length;
            lasti = r.lastIndex;

            if (n) {
                result += m[0];
                if (m[1].indexOf('/') === 0) {
                    //if this is a closing tag, than pop the stack (does not account for bad html)
                    stack.pop();
                } else if (m[1].lastIndexOf('/') !== m[1].length - 1) {
                    //if this is not a self closing tag than push it in the stack
                    stack.push(m[1]);
                }
            }
        }

        //add the remainder of the string, if needed (there are no more tags in here)
        result += s.substr(lasti, n);

        //fix the unclosed tags
        while (stack.length) {
            result += '</' + stack.pop() + '>';
        }

        return result;

    }

    function isAValidEmailAddress(arg) {
        var emailAddress = '';
        if (arg instanceof jQuery)
            emailAddress = arg.val();
        else if (typeof (arg) === 'string' || arg instanceof String)
            emailAddress = arg;
        else if (arg instanceof HTMLInputElement)
            emailAddress = arg.value;
        else
            throw new Error("invalid argument passed to isAValidEmailAddress. expected: (string | jQuery obj | html input), got: " + typeof (arg));

        if (/^\w+([\.\+-]?\w+)*@\w+([\.\+-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)) {
            return true;
        }
        return false;
    }

    function Guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Compare array contents, but order doesn't matter
    function compareArrays(arr1, arr2) {
        // if either array is a falsy value, return
        if (!arr1 || !arr2)
            return false;

        // compare lengths - can save a lot of time 
        if (arr1.length != arr2.length)
            return false;

        for (var i = 0, l = arr1.length; i < l; i++) {
            // Check if we have nested arrays
            if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
                // recurse into the nested arrays
                if (!arr1[i].equals(arr2[i]))
                    return false;
            }
            else if (arr1[i] != arr2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    }

    // Ready Monitor Functionality

    function registerReadyMonitor(monitor, onReadyFunction) {
        ;
        if (typeof _ReadyMonitor[monitor] == 'undefined')
        {
            _ReadyMonitor[monitor] = {
                readyFunction: onReadyFunction,
                subscriptions: {}
            };
        } else {
            logging.error("Duplicate Ready Monitor Key: " + monitor, _ModuleName);
        }
    }

    function subscribeToReadyMonitor(monitor, name) {
        ;
        var readyMonitor = _ReadyMonitor[monitor];
        if (typeof readyMonitor != 'undefined') {
            if (typeof readyMonitor.subscriptions[name] == 'undefined') {
                readyMonitor.subscriptions[name] = false;
            } else {
                logging.error("Unable to subscribe to ready monitor because subscription already exists: " + name, _ModuleName);
            }
        } else {
            logging.error("Unable to subscribe to ready monitor because it does not exist: " + monitor, _ModuleName);
        }
    }

    function isSubscribedToReadyMonitor(monitor, name) {
        var readyMonitor = _ReadyMonitor[monitor];
        if (typeof readyMonitor != 'undefined') {
            if (typeof readyMonitor.subscriptions[name] == 'undefined') {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    function confirmReady(monitor, name) {
        ;
        var readyMonitor = _ReadyMonitor[monitor];
        if (typeof readyMonitor != 'undefined') {
            if (typeof readyMonitor.subscriptions[name] != 'undefined') {
                readyMonitor.subscriptions[name] = true;

                if (_checkReady(monitor)) {
                    ;
                    _executeReadyFunction(monitor);
                    _cleanupReadyMonitors(monitor);
                } else {
                    ;
                }

            } else {
                logging.error("Unable to confirm ready on ready monitor " + monitor + " because subscription does not exist: " + name, _ModuleName);
            }
        } else {
            logging.error("Unable to confirm ready on ready monitor because monitor does not exist: " + monitor, _ModuleName);
        }
    }

    function _checkReady(monitor) {
        if (typeof _ReadyMonitor[monitor] != 'undefined') {
            for (var property in _ReadyMonitor[monitor].subscriptions) {
                if (_ReadyMonitor[monitor].subscriptions.hasOwnProperty(property)) {
                    ;
                    if (_ReadyMonitor[monitor].subscriptions[property] == false) return false;
                }
            }

            return true;
        } else {
            logging.error("Failed to check Ready Monitor for ready status. Monitor Does Not Exist: " + monitor, _ModuleName);
        }

        return false;
    }

    function _executeReadyFunction(monitor) {
        var readyMonitor = _ReadyMonitor[monitor];
        if (typeof readyMonitor != 'undefined') {
            if (typeof readyMonitor.readyFunction == 'function') {
                readyMonitor.readyFunction();
            } else {
                logging.error("Ready Function is not type function. Invalid configuration for montior: " + monitor, _ModuleName);
            }
        } else {
            logging.error("Failed to execute Ready Monitor onReady function. Monitor Does Not Exist: " + monitor, _ModuleName);
        }
    }

    function _cleanupReadyMonitors(monitor) {
        try {
            ;
            delete _ReadyMonitor[monitor];
            ;
        } catch(error) {
            logging.error(error, _ModuleName);
        }
    }

    function setData(elem, name, value)
    {
        // Set Data Value in Memory
        $(elem).data(name, value);
        // Update DOM with Data
        $(elem).attr('data-' + name, value);
    }

    function isArrayInArray(arr, item) {
        for(var i = 0; i < arr.length; i++) {
            if(_.difference(arr[i], item).length == 0) return true;
        }
        return false;
    }

    function removeArrayFromArray(arr, item) {
        var newArr = [];
        for(var i = 0; i < arr.length; i++) {
            if(_.difference(arr[i], item).length > 0) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    }

    var isSixseeds = function( url ){
        var re = /.*\/blogs\/([a-z0-9]+)\.*\//;
        var result = re.exec( url );
        if( result && Array.isArray(result) && result.length > 1) {
            return _sixseedsBlogs.includes( result[1] );
        }
        return false;
    }
    
    var convertToSixSeedsUrl = function( url ) {
        return url.replace("/www.", "/sixseeds.")
                        .replace("/development.", "/sixseeds.")
                        .replace("/local.", "/sixseeds.")
                        .replace("/blogs/", "/")
                        .replace("https://", "http://");
    }

    var load3rdPartyScript = function(url) {
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        var useSSL = 'https:' == document.location.protocol;
        script.src = (useSSL ? 'https:' : 'http:') + url;
        var node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(script, node);
    }

    /**
     * Checks if the dom element is in currently in view
     * @param {*} el dom element
     */
    var elementIsInView = function( el ) {
        if(el) {
            if (typeof jQuery === "function" && el instanceof jQuery) {
                el = el[0];
            }
            var rect = el.getBoundingClientRect();

            return (
                (rect.top >= 0 && rect.top <= (window.innerHeight || $(window).height())) ||
                (rect.bottom >= 0 && rect.bottom <= (window.innerHeight || $(window).height()))
            );
        }

        return false;
    }

    return {
        init: init,
        getCookie: getCookie,
        setCookie: setCookie,
        setCookieByHours: setCookieByHours,
        getParameter: getParameter,
        cleanString: cleanString,
        htmlSubstring: htmlSubstring,
        isAValidEmailAddress: isAValidEmailAddress,
        IsMobile: (function () { return _DeviceType.Phone || _DeviceType.Tablet; }),
        IsPhone: (function () { return _DeviceType.Phone; }),
        IsTablet: (function () { return _DeviceType.Tablet; }),
        IsDesktop: (function () { return _DeviceType.Desktop; }),
        Guid: Guid,
        compareArrays: compareArrays,
        registerReadyMonitor: registerReadyMonitor,
        subscribeToReadyMonitor: subscribeToReadyMonitor,
        isSubscribedToReadyMonitor: isSubscribedToReadyMonitor,
        confirmReady: confirmReady,
        setData: setData,
        isDevelopment: isDevelopment,
        isStaging: isStaging,
        documentReady: documentReady,
        isArrayInArray: isArrayInArray,
        removeArrayFromArray: removeArrayFromArray,
        isSixseeds: isSixseeds,
        convertToSixSeedsUrl: convertToSixSeedsUrl,
        fixYouTubeResponsive: fixYouTubeResponsive,
        load3rdPartyScript: load3rdPartyScript,
        elementIsInView: elementIsInView
    }
});
